export default {
  aovButton: {
    fontSize: '1.4rem',
    minWidth: 190,
    borderRadius: '.5rem',
    marginBottom: '.5rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/CameraDetailsContainer/CameraDetails/MultipleAovSelect/style.js